<template>
  <div class="upload-page-1-container">
    <modal
      :height="250"
      :pivotY="0.5"
      :width="300"
      name="add-new-ea-suggestion"
      style="background-color=#ffffff"
    >
      <div class="text-xs-center add-tag-container">
        <h3>Type the tag name!</h3>

        <v-text-field
          color="#f5a623"
          v-model="addTagModal"
          :autofocus="true"
          @keyup.enter="addTagToSelected('EA')"
        />

        <button class="tag-add-button" @click="addTagToSelected('EA')">Add Tag</button>
      </div>
    </modal>
    <modal :height="250" :pivotY="0.5" :width="300" name="add-new-spot-suggestion">
      <div class="text-xs-center add-tag-container">
        <h3>Type the tag name!</h3>

        <v-text-field
          color="#f5a623"
          v-model="addTagModal"
          :autofocus="true"
          @keyup.enter="addTagToSelected('Spot')"
        />

        <button class="tag-add-button" @click="addTagToSelected('Spot')">Add Tag</button>
      </div>
    </modal>
    <!-- </modal> -->

    <!-------------------------- New UI ------------------------------>
    <div class="upload-screen-1-container">
      <div class="text-xs-left">
        <div class="actions">
          <i
            class="material-icons white--text"
            style=" font-size: 1.1em; cursor:pointer;"
            @click="$router.go(-1)"
          >arrow_back_ios</i>
          <label
            class="upload-title"
          >{{$route.query.resourceType=="image"?'SUBMIT YOUR PHOTO':'SUBMIT YOUR VIDEO'}}</label>
          <div class="tooltip">
            <button
              class="done pointer"
              @click="shareUploadedImage({
          isBulk: false,
           photoId: $route.query.publicId,
           resourceType: $route.query.resourceType,
           monNDur: {mon:_mon2, dur: _dur2},
           anyoneCanVisitThisSpot: $store.state.uploadImage_4.anyoneCanVisitThisSpot_uploadImage,
           myPhoto: true,
           hasGeohash: $store.state.uploadImage_3.geoLocIsAvailable_uploadImage_3,
           uid: $store.state.auth.user.uid,
           uploader: 'user',
           caption: $store.state.uploadImage_2.caption_uploadImage,
           pic_desc: $store.state.uploadImage_3.travelInfo,
           emotionalAppeal: JSON.stringify($store.state.uploadImage_2.selectedemotionalAppeal_uploadImage),
           keywords: JSON.stringify($store.state.uploadImage_5.selectedKeywords_uploadImage),
           spotType: JSON.stringify($store.state.uploadImage_4.selectedSpotType_uploadImage),
           photoSourceLink: $route.query.photoSourceLink,
           licenseType: '',
           licenseLink: '',
           allowCommercialUse: '',
           approved: false,
           geohash: $store.state.uploadImage_3.geohashVal,
          })"
              :style="!$store.state.uploadImage_3.geoLocIsAvailable_uploadImage_3? 'background-color:#5b5b5b;color: #9b9b9b': 'background-color:#bd10e0;color: #ffffff' "
              :disabled="!$store.state.uploadImage_3.geoLocIsAvailable_uploadImage_3?true:false"
            >{{$route.query.resourceType=="image"?'Submit this photo':'Submit this video'}}</button>
            <span
              class="tooltiptext"
              v-if="!$store.state.uploadImage_3.geoLocIsAvailable_uploadImage_3"
            >{{$route.query.resourceType=="image"?'Please select photo location first.':'Please select video location first'}}</span>
          </div>
        </div>
      </div>

      <v-layout row wrap class="img-and-caption-container">
        <v-flex xs4 sm6 md6 lg6 class="img-container">
          <img v-lazy="uploadedImgUrl" v-if="$route.query.resourceType=='image'" />
          <div class="video-container" v-if="$route.query.resourceType=='video'">
            <div
              v-if="$route.query.resourceType=='video'"
              style="position: relative;height: 100%;width:600px"
              class="video-player"
            >
              <iframe
                :src="getVideoLink($route.query.photoSourceLink)"
                frameborder="0"
                v-if="$route.query.photoSourceLink.includes('vimeo')"
                style="
                top:0;
    bottom: 0;
    height: 90%;
    width: 100%;
    right: 0;"
                allow="autoplay; fullscreen"
                allowfullscreen
                @load="imgLoader=false"
              ></iframe>
              <youtube
                v-else
                id="yt_video"
                :video-id="getVideoId($route.query.photoSourceLink)"
                class="video-player-youtube"
                player-width="100%"
                player-height="90%"
                @pause="pause"
                @ready="ready"
                @playing="playing"
              ></youtube>
            </div>
          </div>
          <div class="location-piblic-access">
            <div class="inner-container">
              <!-- location -->
              <div
                class="input-container white--text padding-bottom padding-top location-container"
                v-if="!JSON.parse($route.query.geoLocIsAvailable)"
              >
                <div class="input-container-text" v-if="locationAddress.length !== 0">
                  <button
                    @click="$modal.show('mapModal'); $store.state.uploadImage_2.openMapDialog = true"
                    class="add-location"
                  >
                    <!-- <i class="material-icons">location_on</i> -->
                    Change photo location
                  </button>
                  <div class="address" style="font-size:12px;margin-top:2px;">{{locationAddress}}</div>
                </div>
                <div v-else class="location-button">
                  <button
                    @click="$modal.show('mapModal'); $store.state.uploadImage_2.openMapDialog = true"
                    class="add-location-new"
                  >
                    <!-- <i class="material-icons">location_on</i> -->
                    {{$route.query.resourceType=="image"?'Select photo location':'Select video location'}}
                  </button>
                </div>
              </div>
              <!-- public access -->
              <div class="input-container public-spot-container">
                <label class="container">
                  <input
                    type="checkbox"
                    v-model="$store.state.uploadImage_4.anyoneCanVisitThisSpot_uploadImage"
                  />
                  <span class="checkmark"></span>
                </label>
                <div class="input-label heading-text">Public spot</div>
                <div
                  class="input-container-text white--text sub-text"
                >Photo is NOT taken from a private property</div>
              </div>
            </div>
          </div>
        </v-flex>
        <v-flex xs8 sm6 md6 lg6 class="caption-container">
          <label class="caption-title">Give it a beautiful caption</label>
          <textarea
            v-model="$store.state.uploadImage_2.caption_uploadImage"
            class="caption-text-area"
            placeholder="Start typing here ..."
          />

          <!-- emotional appeal -->
          <div class="input-container">
            <div class="input-label text-xs-left">Describe the feel of this place</div>

            <div class="text-xs-left white--text selected-tags-upload">
              <div class="selected-suggestions">
                <div
                  v-if="$store.state.uploadImage_2.selectedemotionalAppeal_uploadImage.length != 0"
                >
                  <label
                    v-for="(selected_suggestion, sIndex) in $store.state.uploadImage_2.selectedemotionalAppeal_uploadImage"
                    :key="`${sIndex}` "
                  >{{selected_suggestion}}{{sIndex === $store.state.uploadImage_2.selectedemotionalAppeal_uploadImage.length - 1? '': ', '}}</label>
                </div>
                <div v-else>
                  <label class="selected-tags-placeholder">Select below or add new...</label>
                </div>
              </div>
              <!-- <input
                type="text"
                class="selected-suggestions"
                placeholder="Select below ..."
                v-model="$store.state.uploadImage_2.selectedemotionalAppeal_uploadImage"
                disabled
              />-->
            </div>
            <v-layout row>
              <!-- suggestion arr -->
              <v-flex flex-grow-1>
                <div class="suggestions-container" id="selected-emotional-appeal">
                  <div
                    v-for="(suggestion, sIndex) in this.vibeSuggestions"
                    :id="`ea${sIndex}`"
                    :key="`${sIndex}` "
                    class="unselected-suggestion-pills pointer"
                    @click="addOrRemove(suggestion,'EA',`ea${sIndex}`)"
                  >{{suggestion}}</div>
                </div>
              </v-flex>
              <!-- add-new -->
              <div>
                <button
                  class="add-new-btn-suggestion pointer"
                  @click="$modal.show('add-new-ea-suggestion')"
                >Add new</button>
              </div>
            </v-layout>
            <!-- /add-new -->
            <!-- /suggestion arr -->
          </div>
          <!-- emotional appeal -->

          <!-- spot Type -->
          <div class="input-container">
            <div class="input-label text-xs-left">This photo was taken from …</div>

            <div class="text-xs-left white--text selected-tags-upload">
              <div class="selected-suggestions" id="selected-spot-types">
                <div v-if="$store.state.uploadImage_4.selectedSpotType_uploadImage.length != 0">
                  <label
                    v-for="(selected_suggestion, sIndex) in $store.state.uploadImage_4.selectedSpotType_uploadImage"
                    :key="`${sIndex}` "
                  >{{selected_suggestion}}{{sIndex === $store.state.uploadImage_4.selectedSpotType_uploadImage.length - 1? '': ', '}}</label>
                </div>
                <div v-else>
                  <label class="selected-tags-placeholder">Select below or add new...</label>
                </div>
              </div>
              <!-- <input
                type="text"
                class="selected-suggestions"
                placeholder="Select below..."
                v-model="$store.state.uploadImage_4.selectedSpotType_uploadImage"
                disabled
              />-->
            </div>
            <!-- suggestion arr -->
            <v-layout row>
              <v-flex flex-grow-1>
                <div class="suggestions-container">
                  <div
                    v-for="(suggestion, sIndex) in this.spotSuggestions"
                    :id="`s${sIndex}`"
                    :key="`${sIndex}` "
                    class="unselected-suggestion-pills pointer"
                  >
                    <button @click="addOrRemove(suggestion,'spot',`s${sIndex}`)">{{suggestion}}</button>
                  </div>
                </div>
              </v-flex>
              <!-- /suggestion arr -->
              <!-- add-new -->
              <div>
                <button
                  class="add-new-btn-suggestion pointer"
                  @click="$modal.show('add-new-spot-suggestion')"
                >Add new</button>
              </div>
              <!-- /add-new -->
            </v-layout>
          </div>
          <!-- /spot type -->
          <div
            class="image-datetime-upload-heading"
            v-if="$route.query.createdAt==''"
          >When was this photo taken?</div>
          <v-layout row v-if="$route.query.createdAt==''">
            <v-flex xs12 sm6>
              <!-- <div class="image-datetime-upload-heading">Image date</div> -->
              <v-dialog
                ref="dialog1"
                v-model="modal"
                :return-value.sync="date"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div style="display:flex">
                    <div
                      class="date-time-input-box"
                      :style="date==''?'color:#b9b9b9':'color:#f5a623'"
                      v-bind="attrs"
                      v-on="on"
                    >{{date==''?'Select a date':date}}</div>
                    <div v-bind="attrs" v-on="on">
                      <i class="material-icons" style="cursor:pointer;color:white;">calendar_today</i>
                    </div>
                  </div>
                </template>
                <v-date-picker v-model="date" :max="currentDate" scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
                  <v-btn text color="primary" @click="$refs.dialog1.save(date)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-flex>
            <v-flex>
              <v-dialog
                ref="dialog"
                v-model="modal2"
                :return-value.sync="time"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <!-- <div class="image-datetime-upload-heading">Image Time</div> -->
                  <div style="display:flex;">
                    <div
                      class="date-time-input-box"
                      :style="time==''?'color:#b9b9b9':'color:#f5a623'"
                      v-bind="attrs"
                      v-on="on"
                    >{{time==''?'Select a time':time}}</div>
                    <div v-bind="attrs" v-on="on" style="cursor:pointer;color:white;">
                      <i class="material-icons">access_time</i>
                    </div>
                  </div>
                  <p style="visibility:hidden">{{submittableDateTime}}</p>
                </template>
                <v-time-picker v-if="modal2" v-model="time" format="24hr" full-width>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="modal2 = false">Cancel</v-btn>
                  <v-btn text color="primary" @click="$refs.dialog.save(time)">OK</v-btn>
                </v-time-picker>
              </v-dialog>
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
    </div>

    <!-- v-model="$store.state.uploadImage_2.openMapDialog"  -->

    <modal
      name="mapModal"
      @closed="$store.state.uploadImage_2.openMapDialog = false"
      width="60%"
      height="auto"
      class="mapModal"
    >
      <div class="white">
        <!-- search in map -->
        <!-- 1 -->
        <div style="position: relative">
          <input
            id="pac-input"
            placeholder="Search location here..."
            class="map-input-box"
            v-model="imageLocation"
          />
          <!-- locate me -->
          <!-- 2 -->
          <div
            @click="getCurrentGeoLocation"
            class="blue--text my-loc-btn"
            @click.native="$store.state.uploadImage_3.getCenter=true"
            id="locBut"
          >
            <v-icon>location_searching</v-icon>
          </div>
        </div>

        <!-- map -->
        <!-- 3 -->
        <div id="myMap"></div>
        <!-- select marker loc -->
        <!-- 4 -->
        <div style="position:relative" @mouseenter="showMapTooltip()"
            @mouseleave="hideMapTooltip()">
          <button
            :class="imageLocation===''?'select-loc-btn-disabled':'select-loc-btn'"
            @click="selectMarkerLocation()"
            :disabled="imageLocation===''?true:false"
          >SELECT THIS LOCATION</button>
          <span
            class="map-tooltiptext"
            v-if="imageLocation===''?mapTooltip:''"
          >{{$route.query.resourceType=="image"?'Please select photo location first.':'Please select video location first'}}</span>
        </div>
      </div>
    </modal>
    <!-------------------------- /New UI ------------------------------>
  </div>
</template>

<script>
import geo from "geo-hash";
import { ToggleButton } from "vue-js-toggle-button";
import { mapMutations } from "vuex";
import { mapGetters } from "vuex";
//
import travelModal from "./travel-info";
//
import suggestionModal from "./suggestion-model";
import uploadImage from "../../mixin/uploadImage";
import { _index_mon, _index_dur } from "../../helper/dateTimeOrgIndex";
//
export default {
  // compbox data
  metaInfo() {
    return {
      title: "with a view"
    };
  },
  data: () => ({
    selectedSuggestionModel: "",
    dummyArr: [],
    mapTooltip: false,
    items: [],
    model: [],
    imageLocation: "",
    selectedVibeSuggestions: [],
    selectedSpotType: [],
    activator: null,
    attach: null,
    addTagModal: "",
    colors: ["green", "purple", "indigo", "cyan", "teal", "orange"],
    editing: null,
    index: -1,
    currentDate: "",
    vibeSuggestions: [
      "romantic",
      "chill",
      "relax",
      "stunning",
      "spiritual",
      "energetic",
      "breathtaking",
      "party"
    ],
    spotSuggestions: [
      "airbnb",
      "bar",
      "hotel room",
      "private window",
      "restaurant",
      "balcony",
      "office",
      "pool",
      "penthouse",
      "rooftop bar",
      "terrace"
    ],
    nonce: 1,
    menu: false,
    x: 0,
    search: null,
    search2: null,
    y: 0,
    time: "",
    date: "",
    menu: false,
    modal: false,
    menu2: false,
    modal2: false,
    _mon2: "",
    _dur2: ""
  }),
  // compbox watch
  watch: {
    "$store.state.uploadImage_2.openMapDialog": {
      handler() {
        if (this.$store.state.uploadImage_2.openMapDialog) {
          setTimeout(() => {
            this.$store.commit("getMarkerOnCurrentLoc", {
              isLocAvailable: this.$route.query.geoLocIsAvailable,
              geohash: this.$route.query.geohash
            });
          }, 200);
        }
      }
    }
  },

  //
  mixins: [uploadImage],
  methods: {
    ...mapMutations([
      "goTo_uploadImage_3",
      "getMarkerPosition",
      "getCurrentGeoLocation",
      "selectMarkerLocation"
    ]),
    showMapTooltip(){
      console.log("showMapTooltip")
      this.mapTooltip = true;
    },
    hideMapTooltip(){
      console.log("hideMapTooltip")
      this.mapTooltip = false;
    },
    addTagToSelected(type) {
      if (type == "EA") {
        if (this.vibeSuggestions.includes(this.addTagModal)) {
          this.addTagModal = "";
        } else {
          this.$store.state.uploadImage_2.selectedemotionalAppeal_uploadImage.push(
            this.addTagModal
          );
          this.vibeSuggestions.push(this.addTagModal);
          this.addTagModal = "";
          setTimeout(
            function(scope) {
              let element = document.getElementById(
                `ea${scope.vibeSuggestions.length - 1}`
              );
              element.classList.remove("unselected-suggestion-pills");
              let name = "selected-suggestion-pills";
              let arr = element.className.split(" ");
              if (arr.indexOf(name) == -1) {
                element.className += " " + name;
              }
            },
            10,
            this
          );
        }
        this.$modal.hide("add-new-ea-suggestion");
      } else {
        if (this.spotSuggestions.includes(this.addTagModal)) {
          this.addTagModal = "";
        } else {
          this.$store.state.uploadImage_4.selectedSpotType_uploadImage.push(
            this.addTagModal
          );

          this.spotSuggestions.push(this.addTagModal);
          setTimeout(
            function(scope) {
              let element = document.getElementById(
                `s${scope.spotSuggestions.length - 1}`
              );
              element.classList.remove("unselected-suggestion-pills");
              let name = "selected-suggestion-pills";
              let arr = element.className.split(" ");
              if (arr.indexOf(name) == -1) {
                element.className += " " + name;
              }
            },
            10,
            this
          );
          this.addTagModal = "";
        }
        this.$modal.hide("add-new-spot-suggestion");
      }
    },
    getVideoLink(link) {
      let words = link.split("/");
      let id = words[3];
      return (
        `https://player.vimeo.com/video/` + id + `?title=0&byline=0&portrait=0`
      );
    },
    getVideoId(link) {
      let videoId = "";
      if (link.includes("youtu.be")) {
        videoId = link.split("/")[3];
        if (videoId.search("#") !== -1) {
          videoId = videoId.split("#")[0];
        }
        if (videoId.search("/?") !== -1) {
          videoId = videoId.split("?")[0];
        }
      } else {
        var url = new URL(link);
        videoId = url.searchParams.get("v");
      }
      return videoId;
    },
    shareUploadedImage(payload) {
      console.log("**********************", {
        shareUploadedImagePayload: payload
      });
      this.$store.dispatch("SHARE_UPLOAD_IMAGE", payload);
    },
    //
    addOrRemove(suggestion, type, id) {
      if (type == "EA") {
        if (
          this.$store.state.uploadImage_2.selectedemotionalAppeal_uploadImage.includes(
            suggestion
          )
        ) {
          let ind = this.$store.state.uploadImage_2.selectedemotionalAppeal_uploadImage.indexOf(
            suggestion
          );
          this.$store.state.uploadImage_2.selectedemotionalAppeal_uploadImage.splice(
            ind,
            1
          );
          var element = document.getElementById(id);
          element.classList.remove("selected-suggestion-pills");
          var element, name, arr;
          let name = "unselected-suggestion-pills";
          let arr = element.className.split(" ");
          if (arr.indexOf(name) == -1) {
            element.className += " " + name;
          }
        } else {
          this.$store.state.uploadImage_2.selectedemotionalAppeal_uploadImage.push(
            suggestion
          );
          var element = document.getElementById(id);
          element.classList.remove("unselected-suggestion-pills");
          var element, name, arr;
          let name = "selected-suggestion-pills";
          let arr = element.className.split(" ");
          if (arr.indexOf(name) == -1) {
            element.className += " " + name;
          }
        }
      } else if (type == "spot") {
        if (
          this.$store.state.uploadImage_4.selectedSpotType_uploadImage.includes(
            suggestion
          )
        ) {
          let ind = this.$store.state.uploadImage_4.selectedSpotType_uploadImage.indexOf(
            suggestion
          );
          this.$store.state.uploadImage_4.selectedSpotType_uploadImage.splice(
            ind,
            1
          );
          var element = document.getElementById(id);
          element.classList.remove("selected-suggestion-pills");
          var element, name, arr;
          let name = "unselected-suggestion-pills";
          let arr = element.className.split(" ");
          if (arr.indexOf(name) == -1) {
            element.className += " " + name;
          }
        } else {
          this.$store.state.uploadImage_4.selectedSpotType_uploadImage.push(
            suggestion
          );
          var element = document.getElementById(id);
          element.classList.remove("unselected-suggestion-pills");
          var element, name, arr;
          let name = "selected-suggestion-pills";
          let arr = element.className.split(" ");
          if (arr.indexOf(name) == -1) {
            element.className += " " + name;
          }
        }
      }
    },
    //
    FillSelectedArrayValue(val) {
      // console.log({ FillSelectedArrayValue: val });
      let type = val.tagCatType;
      let arr = val.arr;
      switch (type) {
        case "emotionalAppeal": {
          this.$store.state.uploadImage_2.selectedemotionalAppeal_uploadImage = arr;
          // console.log({
          //   EMOTIONAL_NOW: this.$store.state.uploadImage_2
          //     .selectedemotionalAppeal_uploadImage
          // });
          this.$forceUpdate();
          break;
        }
        case "spotType": {
          this.$store.state.uploadImage_4.selectedSpotType_uploadImage = arr;
          this.$forceUpdate();
          break;
        }
        case "keywords": {
          this.$store.state.uploadImage_5.selectedKeywords_uploadImage = arr;
          this.$forceUpdate();
          break;
        }
      }
    },
    // compbox methods
    edit(index, item) {
      if (!this.editing) {
        this.editing = item;
        this.index = index;
      } else {
        this.editing = null;
        this.index = -1;
      }
    },
    filter(item, queryText, itemText) {
      if (item.header) return false;

      const hasValue = val => (val != null ? val : "");

      const text = hasValue(itemText);
      const query = hasValue(queryText);

      return (
        text
          .toString()
          .toLowerCase()
          .indexOf(query.toString().toLowerCase()) > -1
      );
    }
  },
  computed: {
    ...mapGetters([
      "showHideMapInput",
      "showMap",
      "addressDetails",
      "locationAddress"
    ]),
    submittableDateTime() {
      if (this.date != "") {
        const date = new Date(this.date);
        if (this.time != "") {
          const hours = this.time.match(/^(\d+)/)[1];
          const minutes = this.time.match(/:(\d+)/)[1];
          date.setHours(hours);
          date.setMinutes(minutes);
          let createdAt_date = this.date;
          let createdAt_time = this.time;
          this.$store.state.uploadImage_2.createdAt =
            createdAt_date + "T" + createdAt_time + "Z"; //2017-12-21T18:14:58Z //format
          let _mon =
            this.$store.state.uploadImage_2.createdAt[5] +
            this.$store.state.uploadImage_2.createdAt[6];
          this._mon2 = _index_mon(_mon);
          // console.log(this._mon2);
          let _dur = parseInt(
            this.$store.state.uploadImage_2.createdAt[11] +
              this.$store.state.uploadImage_2.createdAt[12]
          );
          this._dur2 = _index_dur(_dur);
          // console.log(this._dur2);
        }
      }
    },
    parsedEmotionalType() {
      let a = [];
      for (let i in this.$store.state.uploadImage_2
        .emotionalAppeal_uploadImage) {
        console.log(
          `1 `,
          this.$store.state.uploadImage_2.emotionalAppeal_uploadImage[i]
        );
        let tmp = {
          text: this.$store.state.uploadImage_2.emotionalAppeal_uploadImage[i]
        };
        a.push(tmp);
      }
      return a;
    },
    parsedSpotType() {
      let a = [];
      for (let i in this.$store.state.uploadImage_4.spotType_uploadImage) {
        // console.log(
        //   `1 `,
        //   this.$store.state.uploadImage_4.spotType_uploadImage[i]
        // );
        let tmp = {
          text: this.$store.state.uploadImage_4.spotType_uploadImage[i]
        };
        a.push(tmp);
      }
      return a;
    }
  },
  created() {
    let vm = this;
    this.$store.state.uploadImage_4.anyoneCanVisitThisSpot_uploadImage = true;
    this.$store.state.uploadImage_3.locationAddress = "";
    this.$store.state.uploadImage_3.geohashVal = this.$route.query.geohash;
    this.$store.state.uploadImage_3.geoLocIsAvailable_uploadImage_3 = JSON.parse(
      this.$route.query.geoLocIsAvailable
    );
    if (JSON.parse(this.$route.query.geoLocIsAvailable)) {
      //console.log('1', geo.decode(payload.geohash))
      let lat = geo.decode(this.$route.query.geohash).lat;
      let lng = geo.decode(this.$route.query.geohash).lon;

      this.$store.commit("getInitAddress", {
        lat,
        lng
      });
    }
    this.$store.state.uploadImage_2.qStr_searchThisTag = "";
    this.$store.state.uploadImage_2.caption_uploadImage = "";
    this.$store.state.uploadImage_2.selectedemotionalAppeal_uploadImage = [];
    this.$store.state.uploadImage_2.qStr_tags2_uploadImage = [];
    this.$store.state.uploadImage_4.selectedSpotType_uploadImage = [];
    this.$store.state.uploadImage_2.qStr_tags2_uploadImage = [];
    window.thisOfVueComp = this;

    setTimeout(() => {
      /*this.$store.commit('getMarkerOnCurrentLoc', {
          isLocAvailable:vm.$route.query.geoLocIsAvailable,
          geohash: vm.$route.query.geohash
        }) */
    }, 1000);
    //
    this.$store.commit("setEmptyVar_ls"); //set local storgae to empty array.
    //
    this.$store.state.uploadImage_2.createdAt = this.$route.query.createdAt;
    this._mon2 = this.$route.query._mon2;
    this._dur2 = this.$route.query._dur2;
    let curDate = new Date();
    let curFullYear = curDate.getFullYear();
    let curMonth = curDate.getMonth() + 1;
    let curDay = curDate.getDate();
    if (curDay < 10) {
      curDay = "0" + curDay;
    }
    this.currentDate = curFullYear + "-" + curMonth + "-" + curDay;
  },
  components: {
    suggestionModal,
    travelModal,
    ToggleButton
  },
  mounted() {
    this.$store.commit("getSpotTypeSuggestions_fromLocalStorage");
  }
  //
};
</script>

<style scoped lang="scss">
@import "../../assets/scss/uploadScreen-1";
@import "../../assets/scss/upload/suggestion.scss";
@import "../../assets/scss/common/tooltip.scss";
.border-bottom {
  border-bottom: solid 0.5px rgba(155, 155, 155, 0.5);
}
.padding-bottom {
  padding-bottom: 1em;
  // padding-top: 1em;
}
.padding-top {
  padding-top: 1em;
}
#myMap {
  height: 60vh;
  width: 100%;
  z-index: 10 !important;
}
#pac-input {
  z-index: 1000 !important;
  position: relative;
  padding: 10px 3.5em 10px 10px;
  outline: none;
  width: 100%;
  .pac-container {
    position: absolute !important;
    z-index: 1000 !important;
    top: 0;
    /*display: block!important;*/
    box-shadow: none;
    font-family: "Lato", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .pac-icon {
    // display: none;
  }
  .pac-item {
    background: transparent
      url("https://png.icons8.com/ios/22/000000/marker.png") no-repeat 22px
      center;
    padding-top: 15px;
    padding-right: 25px;
    position: relative;
    line-height: 20px;
    padding-bottom: 15px;
    padding-left: 65px;
    /* border: none; */
  }

  .pac-item span:nth-child(3)::before {
    content: "\A";
    white-space: pre;
  }

  .pac-item span:nth-child(3) {
  }

  .pac-item:hover {
    background-color: lightgrey;
  }
  .pac-item-selected {
  }
  .pac-item-query {
    font-weight: bold;
  }
  .pac-matched {
  }

  div.pac-container.pac-logo::after {
    display: none;
  }

  span.pac-icon.pac-icon-marker {
  }
}

.search-loc-loc-me {
  margin-top: 5px;
}
.true {
  visibility: visible;
}
.false {
  visibility: hidden;
}
.image-thumbnail {
  object-fit: contain;
}
.my-loc-btn {
  position: absolute;
  right: 20px;
  top: 10px;
}
.select-loc-btn {
  width: 100%;
  padding: 10px 20px;
  text-align: center;
  background-color: $primary-color-3;
  color: #ffffff;
  opacity: 1;
  font-family: Montserrat;
}

.select-loc-btn-disabled {
  width: 100%;
  padding: 10px 20px;
  text-align: center;
  opacity: 0.9;
  font-family: Montserrat;
  background-color: #5b5b5b;
  color: #9b9b9b;
}

.travel-info {
  outline: none;
  border-bottom: 1px solid white !important;
  width: 100%;
}
.v--modal {
}
.video-player-youtube {
  position: relative;
  height: 100%;
  width: 100%;
}
.share-btn-container {
  left: 0;
  width: 100%;
  position: absolute;
  bottom: 1.5em;
}
.share-img-btn {
  margin-top: 2em;
  max-width: 270px;
  width: 100%;
  background-color: black;
  color: #ffffff;
  font-size: 0.9em;
  line-height: 2;
  border-radius: 6px;
}
.map-tooltiptext {
  position: absolute;
  z-index: 10;
  top: -35px;
  left: 0;
  background-color: black;
  border: 0.2px solid white;
  border-radius: 5px;
  color: #fff;
   padding: 5px;
  text-align: center;
}

.map-tooltiptext::after {
  content: "";
  position: absolute;
  top: -11px;
  left: 50%;
  margin-right: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent #fff transparent;
}
</style>



// WEBPACK FOOTER //
// uploadImage_2.vue?4983266d